/**
 * PersonsRoleGuard - Protege os submenus especialistas de Pessoas.
 *
 * Resolve o tipo pela rota (/tenant/persons/:role) e aplica a permissão
 * própria do submenu. Tipo desconhecido volta para a lista geral.
 *
 * RELEASE: 2026-10-06 v1.0.0 - Versão inicial.
 */
import type { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { PermissionGuard } from '@/components/PermissionGuard';
import { PERSON_ROLE_SECTIONS } from '@/hooks/usePersons';

export function PersonsRoleGuard({ children }: { children: ReactNode }) {
  const { role } = useParams<{ role?: string }>();
  const section = PERSON_ROLE_SECTIONS.find((s) => s.slug === role);
  // Rota inválida: não expõe nada, só redireciona
  if (!section) return <Navigate to="/tenant/persons/fornecedores" replace />;
  return <PermissionGuard menuKey={section.menuKey}>{children}</PermissionGuard>;
}
